module.exports = __webpack_public_path__ + "static/media/SHSProdIcons__Fitness_Watch.093e898c.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/homepage/resources/SHSProdIcons__Fitness_Watch.svg
// module id = 1616
// module chunks = 0